// Third-party imports
import $ from 'jquery';

export function updateCartButtonIndicator() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
            let itemsInCart = 0;
            for (let i = 0; i < cart.items.length; i++) {
                if (cart.items[i].product_type !== 'Topup') {
                    if ( cart.items[i].product_type === 'Gift Catalogue' 
                        && cart.items[i].quantity > 1) {
                        itemsInCart += cart.items[i].quantity;
                    }
                    else {
                        itemsInCart += 1;//Incase of donation product (like give it where most needed) increase the cart/basket count by 1
                    }
                }
            }
            if (itemsInCart > 0) {
                $('.cart-button-indicator').each(function () {
                    $(this)
                        .html(itemsInCart.toString())
                        .removeClass('basket-basketIndicator-hide');
                });
            }
        },
    });
}
